import { KebabMenu as ChordsKebabMenu } from '~/chords/KebabMenu';

export const KebabMenu = ChordsKebabMenu;
